import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

interface SearchFieldProps {
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
}

export default function SearchField({ placeholder, value, onChange }: SearchFieldProps) {
    return (
        <TextField
            size="small"
            hiddenLabel
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchRoundedIcon fontSize="small" />
                        </InputAdornment>
                    ),
                },
            }}
            sx={{
                width: 240,
                maxWidth: 400,
                transition: "width 0.3s ease",
                "&:focus-within": {
                    width: 400,
                },
            }}
        />
    );
}
